import classNames from 'classnames';
import React, { LegacyRef, useEffect, useRef } from 'react';
import { useMeasure } from 'react-use';
import { Section } from '../types';
import { NeuePlayerDesktopContent } from './desktop-content';
import { DesktopNavigationBar } from './desktop-navigation-bar';
import { usePlayerStore } from './player-store';

export const NeuePlayerDesktopView = () => {
  const {
    layout: { renderElements, innerActualHeight, innerActualWidth, layoutReady },
    setLayoutSizes,
    setBlockContentSize,
    setCanvasScrollPosition,
    setPlayerContentElement,
  } = usePlayerStore();
  const [innerLegacyRef, innerRect] = useMeasure();
  const innerRef = useRef<HTMLDivElement>();
  const [editorContentLegacyRef, editorContentRect] = useMeasure();
  const [editorContentEl, setEditorContentEl] = React.useState<HTMLDivElement | null>(null);

  useEffect(() => {
    if (editorContentEl) {
      const handleScroll = () => {
        setCanvasScrollPosition(editorContentEl.scrollLeft, editorContentEl.scrollTop);
      };
      editorContentEl.addEventListener('scroll', handleScroll);
      return () => {
        editorContentEl.removeEventListener('scroll', handleScroll);
      };
    }
  }, [editorContentEl]);

  useEffect(() => {
    if (innerRef.current && editorContentEl) {
      const innerRect = innerRef.current.getBoundingClientRect();
      const editorContentRect = editorContentEl.getBoundingClientRect();
      setLayoutSizes({
        width: innerRect.width,
        height: editorContentRect.height, // Note, need this to be the height of the editorContent, not the outer area
      });
      setPlayerContentElement(editorContentEl);
    }
  }, [innerRect, editorContentRect]);

  return (
    <div className='w-full h-full bg-white overflow-hidden relative'>
      <div
        className='w-full h-full overflow-y-auto'
        ref={
          ((element: HTMLDivElement) => {
            setEditorContentEl(element);
            editorContentLegacyRef(element);
          }) as LegacyRef<HTMLDivElement>
        }
      >
        <div
          className={classNames('relative mx-auto max-w-[1000px] flex-1', {})}
          ref={
            ((element: HTMLDivElement) => {
              innerRef.current = element;
              innerLegacyRef(element);
            }) as LegacyRef<HTMLDivElement>
          }
        >
          {layoutReady && (
            <NeuePlayerDesktopContent
              width={innerActualWidth || 0}
              height={innerActualHeight || 0}
              renderElements={renderElements}
              onBlockSize={(blockId, size) => setBlockContentSize(blockId, size)}
            />
          )}
        </div>
      </div>
      <div className='absolute z-[300] right-5 bottom-6 pointer-events-none'>
        <DesktopNavigationBar />
      </div>
    </div>
  );
};
